import React from 'react'
import { NavLink, Link } from 'react-static'
import Logo from '../Logo'
import styles from './styles.module.css'

export default () => (
    <section className={styles.meta}>
        <Logo />

        <ul className={styles.nav}>
            <li><NavLink to="/blog" activeClassName={styles.active}>Blog</NavLink></li>
            <li><NavLink to="/about" activeClassName={styles.active}>About</NavLink></li>
        </ul>

        <p>
            Massive Robot is the journal of <Link to="/about">Dan Webb</Link>, an old school web guy who's learning about
            3D graphics programming, XR and computer vision.
        </p>
        <h2>Elsewhere...</h2>
        <ul className={styles.elsewhere}>
            <li><a href="https://twitter.com/danwrong" className={styles.twtr}>@danwrong</a></li>
            <li><a href="https://github.com/danwrong" className={styles.github}>/danwrong</a></li>
            <li><a href="https://soundcloud.com/danwrong" className={styles.soundcloud}>/danwrong</a></li>
            <li><a href="https://www.linkedin.com/in/dan-webb-04b562/" className={styles.linkedin}>Dan Webb</a></li>
        </ul>
    </section>
)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Sidebar/index.js